import { render, staticRenderFns } from "./UserEducationCreateModal.vue?vue&type=template&id=5224ccd8&scoped=true&"
import script from "./UserEducationCreateModal.vue?vue&type=script&lang=js&"
export * from "./UserEducationCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./UserEducationCreateModal.vue?vue&type=style&index=0&id=5224ccd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5224ccd8",
  null
  
)

export default component.exports